import React, { useRef } from "react";
import { useInView, useReducedMotion } from "framer-motion";
type TypographyMarqueeProps = {
  reverse?: boolean;
};
const phrase = "MOVE • STRENGTH • MOBILITY • PERFORMANCE • PURPOSE •";
export function TypographyMarquee({
  reverse = false
}: TypographyMarqueeProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    margin: "120px 0px"
  });
  const reduceMotion = useReducedMotion();
  return <div ref={ref} className="overflow-hidden border-y border-ink/15 bg-cream py-5 sm:py-7" aria-hidden="true" data-id="element-257" data-mp="1cwl9pts7uio5">
      <div className={`marquee-track flex w-max whitespace-nowrap ${reverse ? "marquee-track-reverse" : ""}`} style={{
      animationPlayState: isInView && !reduceMotion ? "running" : "paused"
    }} data-id="element-258" data-mp="1huwl48y5t18h">
        {[0, 1].map(copy => <p key={copy} className="pr-8 font-display text-5xl font-semibold uppercase leading-none tracking-[-0.035em] text-ink sm:pr-12 sm:text-7xl lg:text-8xl" data-id="element-259" data-mp="2xdhpwot4psc6">
            {phrase}
          </p>)}
      </div>
    </div>;
}